import { Component, Input, ElementRef, AfterViewInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DropdownModule } from 'primeng/dropdown';
import { News } from '@/app/plateformebeneficiaire/core/models/news.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-news-details',
  templateUrl: './news-details.component.html',
  standalone: true,
  imports: [DropdownModule, CommonModule],
})
export class NewsDetailsComponent implements OnChanges {
  @Input() news!: News | null;
  @Input() showMotsCles = false;
  @Input() showMotCles = false;

  // Propriété calculée une seule fois pour éviter les appels répétés
  processedContent: SafeHtml = '';
  
  private callCount = 0;

  constructor(private sanitizer: DomSanitizer) {}


  // Code un peu spécial car le safeHTML est recalculé trop souvent, de ce fait le viewer scintille
  // En stockant le HTML dans le composant, on évite ce problème


  ngOnChanges(changes: SimpleChanges): void {
    // Recalculer le contenu seulement quand les news changent
    if (changes['news'] && this.news?.contenu) {
      console.log('🔄 Recalcul du contenu HTML pour nouvelles news');
      this.processedContent = this.sanitizer.bypassSecurityTrustHtml(this.news.contenu);
    }
  }

  getSafeHtml(html: string | undefined): SafeHtml {
    this.callCount++;
    console.log(`⚠️ getSafeHtml appelée ${this.callCount} fois ! Ceci devrait être évité.`);
    
    if (!html) return '';
    
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
